import { coerceBooleanProperty } from '@angular/cdk/coercion';
import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-step',
  templateUrl: './step.component.html',
  styleUrls: ['./step.component.scss'],
})
/**
 * Step atom that reprents a circle that might be active or not
 */
export class StepComponent {
  private _active: boolean = false;

  /**
   * If this step is active or not
   */
  @Input()
  get active(): boolean {
    return this._active;
  }

  /**
   * Sets this step as an active step
   * @param {any} value value might be any type and it is coerced into a boolean
   */
  set active(value: any) {
    this._active = coerceBooleanProperty(value);
  }
}
